export default __webpack_public_path__ + "static/media/NoResults.9403ef2b26d886fc.svg";